module.exports = __webpack_public_path__ + "static/img/diyim2.4401c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyim2.png
// module id = nONa
// module chunks = 5